import {
  createContext,
  type ReactNode,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import { DealPhaseValue, type DealPhaseValueType } from "../types/enums/labels";

interface DealPhaseContextValue {
  dealPhase: DealPhaseValueType;
  setDealPhase: (phase: DealPhaseValueType) => void;
}

const DealPhaseContext = createContext<DealPhaseContextValue | null>(null);

export function DealPhaseProvider({ children }: { children: ReactNode }) {
  const [dealPhase, setDealPhaseState] = useState<DealPhaseValueType>(DealPhaseValue.All);

  const setDealPhase = useCallback((phase: DealPhaseValueType) => {
    setDealPhaseState(phase);
  }, []);

  const value = useMemo(
    () => ({ dealPhase, setDealPhase }),
    [dealPhase, setDealPhase]
  );

  return (
    <DealPhaseContext.Provider value={value}>
      {children}
    </DealPhaseContext.Provider>
  );
}

// eslint-disable-next-line react-refresh/only-export-components -- context files intentionally co-locate Provider + hook
export function useDealPhase(): DealPhaseContextValue {
  const ctx = useContext(DealPhaseContext);
  if (ctx == null) {
    throw new Error("useDealPhase must be used within DealPhaseProvider");
  }
  return ctx;
}
